// Drivers raise this when the browser refuses to open a wallet's popup, so the
// form can tell the donor what to do without knowing the gateway's error codes.
export class PaymentPopupBlockedError extends Error {
  constructor(message = "Payment popup was blocked by the browser") {
    super(message);
    this.name = "PaymentPopupBlockedError";
  }
}
